import { render, staticRenderFns } from "./activity_blacklist.vue?vue&type=template&id=43549ac2&scoped=true&"
import script from "./activity_blacklist.vue?vue&type=script&lang=js&"
export * from "./activity_blacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43549ac2",
  null
  
)

export default component.exports